import { createStyles } from '@material-ui/core/styles'

export default () =>
  createStyles({
    root: { position: 'absolute', right: 0, top: 0 , color: "#fff"}
  })
